(function () {
  'use strict';
 
  // ── Only run on product pages ────────────────────────────────
  if (!window.location.pathname.includes('/products/')) return;
 
  // ── Create Sticky ATC Bar ─────────────────────────────────────
  function createStickyBar() {
    if (document.getElementById('csk-sticky-atc')) return;
 
    // Get product info from the page
    const productTitle = document.querySelector(
      '.product__title h1, h1.product__title, [class*="product__title"] h1, h1'
    )?.textContent?.trim() || 'This pair';
 
    const productPrice = document.querySelector(
      '.price__regular .price-item, .price-item--regular, [class*="price"] .money'
    )?.textContent?.trim() || '';
 
    // Build the bar HTML
    const bar = document.createElement('div');
    bar.id = 'csk-sticky-atc';
    bar.innerHTML = `
      <span class="csk-sticky-product-name">🧦 ${productTitle}</span>
      <span class="csk-sticky-price">${productPrice}</span>
      <button class="csk-sticky-btn" id="csk-sticky-atc-btn" type="button">
        Yes, I want these 🧦
      </button>
    `;
 
    document.body.appendChild(bar);
    return bar;
  }
 
  // ── Show/Hide based on ATC button scroll position ────────────
  function initScrollBehavior() {
    const stickyBar = document.getElementById('csk-sticky-atc');
    if (!stickyBar) return;
 
    // The original ATC button on the product page
    const originalBtn = document.querySelector(
      '.product-form__submit, button[name="add"], [class*="product-form"] button[type="submit"]'
    );
    if (!originalBtn) return;
 
    let lastScrollY = window.scrollY;
    let ticking = false;
 
    function checkScroll() {
      const btnRect = originalBtn.getBoundingClientRect();
      const isBtnOutOfView = btnRect.bottom < 0;
 
      if (isBtnOutOfView) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
      ticking = false;
    }
 
    window.addEventListener('scroll', () => {
      lastScrollY = window.scrollY;
      if (!ticking) {
        requestAnimationFrame(checkScroll);
        ticking = true;
      }
    }, { passive: true });
  }
 
  // ── Sticky button click: submit the original form ─────────────
  function initStickyButton() {
    const stickyBtn = document.getElementById('csk-sticky-atc-btn');
    if (!stickyBtn) return;
 
    stickyBtn.addEventListener('click', async () => {
      if (stickyBtn.classList.contains('loading')) return;
 
      // Find and click the original form's submit button
      const originalForm = document.querySelector(
        'form[action="/cart/add"], .product-form form, [class*="product-form"] form'
      );
      const originalBtn = document.querySelector(
        '.product-form__submit, button[name="add"]'
      );
 
      if (!originalForm && !originalBtn) {
        // Fallback scroll to the button
        const atcSection = document.querySelector('.product__info-wrapper, .product');
        if (atcSection) atcSection.scrollIntoView({ behavior: 'smooth' });
        return;
      }
 
      // Set loading state
      stickyBtn.classList.add('loading');
      stickyBtn.textContent = 'Adding... ⏳';
 
      try {
        // Get form data
        const formData = originalForm ? new FormData(originalForm) : null;
 
        if (formData) {
          // Submit via AJAX
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
 
          if (!response.ok) throw new Error('Failed');
 
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
 
          // Update cart count
          updateCartCount(cart.item_count);
 
          // Show success
          stickyBtn.classList.remove('loading');
          stickyBtn.classList.add('success');
          stickyBtn.textContent = '✓ Added to cart!';
 
          // Show original cart notification if it exists
          if (originalBtn) originalBtn.click();
 
          setTimeout(() => {
            stickyBtn.classList.remove('success');
            stickyBtn.textContent = 'Yes, I want these 🧦';
          }, 2500);
 
        } else if (originalBtn) {
          // Fallback: click the original button
          originalBtn.click();
          stickyBtn.classList.remove('loading');
          stickyBtn.textContent = '✓ Added!';
          setTimeout(() => {
            stickyBtn.textContent = 'Yes, I want these 🧦';
          }, 2000);
        }
 
      } catch (err) {
        stickyBtn.classList.remove('loading');
        stickyBtn.textContent = 'Yes, I want these 🧦';
        console.warn('[CSK Sticky ATC] Error:', err);
        // Scroll to ATC button as fallback
        if (originalBtn) originalBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
 
  // ── Update cart count in header ───────────────────────────────
  function updateCartCount(count) {
    document.querySelectorAll(
      '.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span'
    ).forEach(el => {
      el.textContent = count;
    });
  }
 
  // ── Add shipping badge below price on product pages ──────────
  function injectShippingBadge() {
    // Don't inject twice
    if (document.querySelector('.csk-shipping-badge')) return;
 
    // Find the price element to inject after
    const priceTarget = document.querySelector(
      '.product__info-wrapper .price, .product-info .price, .price__container'
    );
    if (!priceTarget) return;
 
    const badge = document.createElement('div');
    badge.className = 'csk-shipping-badge';
    badge.innerHTML = `
      <span class="csk-ship-item">
        📦 Cairo/Giza: <strong>E£65</strong>
      </span>
      <span class="csk-ship-item">
        📦 Alexandria: <strong>E£120</strong>
      </span>
      <span class="csk-ship-item free-badge">
        🚀 Free shipping over E£1,000!
      </span>
    `;
 
    // Insert after price
    priceTarget.parentNode.insertBefore(badge, priceTarget.nextSibling);
  }
 
  // ── Main init ─────────────────────────────────────────────────
  function init() {
    createStickyBar();
    initScrollBehavior();
    initStickyButton();
    injectShippingBadge();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
})();
 
/* ============================================================
   END OF CSK STICKY CART JS
   ============================================================ */